export enum IntegrationTarget {
  KANDJI = "Kandji",
}